/**
 * Shared chart chrome so every Recharts chart reads as one system: axis tick
 * text in the muted ink, one plot margin, and legend labels in the secondary
 * ink (text never wears a series color).
 */

export const AXIS_TICK = { fill: "var(--viz-muted)", fontSize: 12 } as const;

export const CHART_MARGIN = { top: 8, right: 16, bottom: 0, left: 0 } as const;

export function legendText(value: string) {
  return (
    <span style={{ color: "var(--viz-ink-secondary)", fontSize: 12 }}>
      {value}
    </span>
  );
}
